// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"fa2c5353","585":"28413e22","833":"da060297"}[chunkId] + ".chunk.js";
};